import { DayPicker, TZDate, type DayPickerProps } from 'react-day-picker';
import 'react-day-picker/style.css';

/** A caller supplies its business timezone; the workstation never selects it. */
export function calendarDate(day: string, timeZone: string): Date {
  const [year, month, date] = day.split('-').map(Number);
  return new TZDate(year!, month! - 1, date!, 12, 0, 0, timeZone);
}
export function calendarDay(date: Date, timeZone: string): string {
  const zoned = new TZDate(date, timeZone);
  return `${zoned.getFullYear()}-${String(zoned.getMonth()+1).padStart(2,'0')}-${String(zoned.getDate()).padStart(2,'0')}`;
}
/** Reuse DayPicker's keyboard, month navigation and range selection primitives. */
export default function Calendar(props: DayPickerProps & { readonly timeZone: string }) {
  return <DayPicker {...props} className={`ac-calendar ${props.className ?? ''}`} weekStartsOn={props.weekStartsOn ?? 1} formatters={{formatWeekdayName: date=>date.toLocaleDateString('en-GB',{weekday:'short',timeZone:props.timeZone}),...props.formatters}} />;
}
